module.exports = __webpack_public_path__ + "static/media/check_circle.2bd06172.svg";